import { PropertyDetails } from "../../WatchList/ViewProperty/PropertyDetails";

const PropertySummary: React.FC<{ propertyAddress: string }> = ({ propertyAddress }) => {
  return (
    <>
      <>
        <PropertyDetails isFromPropertyAnalyser={true} propertyAddress={propertyAddress}></PropertyDetails>
      </>
    </>
  );
};

export default PropertySummary;
